import { BooleanInput } from '@angular/cdk/coercion';
import {
  ChangeDetectionStrategy,
  Component,
  booleanAttribute,
  computed,
  input,
} from '@angular/core';
import { Card } from '../card/card.component';

const DEFAULT_LOADING_DIAMETER = 40;
const COMPACT_LOADING_DIAMETER = 24;

@Component({
  selector: 'procure-kpi-widget',
  templateUrl: './kpi-widget.component.html',
  styleUrl: './kpi-widget.component.scss',
  imports: [Card],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class KpiWidget {
  readonly kpi = input.required<string | number>();

  readonly label = input.required<string>();

  readonly isLoading = input<boolean, BooleanInput>(false, {
    transform: booleanAttribute,
  });

  readonly light = input<boolean, BooleanInput>(false, {
    transform: booleanAttribute,
  });

  readonly compact = input<boolean, BooleanInput>(false, {
    transform: booleanAttribute,
  });

  readonly isEmpty = computed(() => {
    return this.kpi() === 'n/a';
  });

  readonly loadingDiameter = computed(() => {
    return this.compact() ? COMPACT_LOADING_DIAMETER : DEFAULT_LOADING_DIAMETER;
  });
}
